const BillingToggle = ({ cycle, setCycle }) => (
    <div className="flex items-center gap-2 mt-4 justify-center">
      <button
        onClick={() => setCycle("monthly")}
        className={`md:px-3 px-2 py-1 rounded-full text-sm ${
          cycle === "monthly" ? "bg-black text-white" : "bg-gray-100"
        }`}
      >
        Bill Monthly
      </button>
  
      <button
        onClick={() => setCycle("yearly")}
        className={`md:px-3 px-2 py-1 rounded-full text-sm ${
          cycle === "yearly" ? "bg-black text-white" : "bg-gray-100"
        }`}
      >
        Bill Yearly
      </button>
  
      <span className="bg-pink-500 text-white text-xs px-2 py-0.5 rounded-full">
        Save 10%
      </span>
    </div>
  );
  
  export default BillingToggle;
  